/* eslint-disable jsx-a11y/anchor-is-valid */

import "perfect-scrollbar/dist/css/perfect-scrollbar.min.css";

import * as Ps from "perfect-scrollbar";

import { NavLink, withRouter } from "react-router-dom";
import React, { Component } from "react";
import { compose, graphql } from "react-apollo";

import Avatar from "react-avatar";
import { Collapse } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { LinkContainer } from "react-router-bootstrap";
import { Modal } from "react-bootstrap";
import Queries from "../../queries/queries2";
import Spinner from "../../elements/Spinner/Spinner";
// image for avatar in Sidebar
import avatar from "../../assets/img/default-avatar.png";
import dashRoutes from "../../routes/dash.jsx";
import image from "../../assets/img/full-screen-image-3.jpg";
import { logout } from "../../tools/logout";

// this is used to create scrollbars on windows devices like the ones from apple devices

// backgroundImage for Sidebar

// import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

const bgImage = {
  backgroundColor: "#2B2C2E"
  //backgroundImage: "url(" + image + ")"
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    const inExpenseShow = this.getExpenseShow();
    if (inExpenseShow) {
      document.body.classList.add("sidebar-mini");
    }
    this.state = {
      openAvatar: false,
      openCompany: false,
      navExpanded: !inExpenseShow,
      navExpandedUserPreference: true,
      // openComponents: (this.activeRoute("/components") !== '' ? true:false),
      // openForms: (this.activeRoute("/forms") !== '' ? true:false),
      // openTables: (this.activeRoute("/tables") !== '' ? true:false),
      // openMaps: (this.activeRoute("/maps") !== '' ? true:false),
      // openPages: (this.activeRoute("/pages") !== '' ? true:false),

      openContacts: this.activeRoute("/contacts") !== "" ? true : false,
      openReports: this.activeRoute("/reports") !== "" ? true : false,
      openSettings: this.activeRoute("/settings") !== "" ? true : false,
      isWindows: navigator.platform.indexOf("Win") > -1 ? true : false,
      width: window.innerWidth
    };
  }

  getExpenseShow = () => {
    const inExpenseShow =
      (this.props.location.pathname.startsWith("/expenses/") &&
        !this.props.location.pathname.endsWith("/expenses/")) ||
      (this.props.location.pathname.startsWith("/reports/") &&
        !this.props.location.pathname.endsWith("/reports/"));
    return inExpenseShow;
  };

  //changes sideNav width
  // handleMinimizeSidebar() {
  //   if (this.state.navExpanded) {
  //     document.body.classList.add("sidebar-mini");
  //     console.log("handleMinimizeSidebar setState1");
  //     this.setState({ navExpanded: false, navExpandedUserPreference: false });
  //   } else {
  //     document.body.classList.remove("sidebar-mini");
  //     console.log("handleMinimizeSidebar setState2");
  //     this.setState({ navExpanded: true, navExpandedUserPreference: true });
  //   }
  // }

  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    // console.log(
    //   "activeRoute",
    //   this.props.location.pathname,
    //   routeName,
    //   this.props.location.pathname.indexOf(routeName)
    // );
    return this.props.location.pathname.indexOf(routeName) === 0
      ? "active"
      : "";
  }
  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions() {
    if (this._ismounted) {
      // console.log("updateDimensions setState");
      this.setState({ width: window.innerWidth });
    }
    // else {
    //   // console.log("component no mounted - skip updateDimensions setState");
    // }
  }

  componentWillUnmount() {
    this._ismounted = false;
  }
  componentDidMount() {
    this._ismounted = true;
    this.updateDimensions();

    // add event listener for windows resize
    window.addEventListener("resize", this.updateDimensions.bind(this));
    //  TODO: this event listen might trigger when component isnt mounted anymore - have to check this

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      Ps.initialize(this.refs.sidebarWrapper, {
        wheelSpeed: 2,
        suppressScrollX: true
      });
    }
  }
  componentDidUpdate(newProps) {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      setTimeout(() => {
        this.refs &&
          this.refs.sidebarWrapper &&
          Ps.update(this.refs.sidebarWrapper);
      }, 350);
    }
    // if (this.props.location.pathname !== newProps.location.pathname) {
    //   const inExpenseShow = this.getExpenseShow();

    //   if (inExpenseShow) {
    //     // document.body.classList.add("sidebar-mini");
    //     // // console.log("componentDidUpdate setState1");
    //     this.setState({ navExpanded: false });
    //     this.props.handleMinimizeSidebar(false);

    //   } else {
    //     if (this.state.navExpandedUserPreference) {
    //       // document.body.classList.remove("sidebar-mini");
    //       // // console.log("componentDidUpdate setState2");
    //       this.setState({ navExpanded: !inExpenseShow });
    //       this.props.handleMinimizeSidebar(true);
    //     }
    //   }
    // }
  }
  // function that creates perfect scroll bar for windows users (it creates a scrollbar that looks like the one from apple devices)
  isMac() {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  render() {
    // if (this.props.userProfile.loading || this.props.companyQuery.loading) {
    //   return <Spinner />;
    // }
    // console.log("sidebar render props", this.props);
    const user = this.props.userProfile && this.props.userProfile.loggedInUser;
    const company = this.props.companyQuery.company;
    const nameStr = (user && `${user.firstname} ${user.name}`) || "";

    // console.log("sidebar state", this.state);
    // const email = (user && user.email) || "NA";
    const firstName = (user && user.firstname) || "N_A";
    // const lastName = (user && user.name) || "Doe";
    const companyName = (company && company.name) || "N_A";

    var emptyMiniStyle = {
      display: "inline-block",
      margin: "0",
      textAlign: "center",
      height: "3px"
    };
    var sideBarStyle = {
      display: "flex",
      maxHeight: "100%",
      flexDirection: "column"
    };

    let userStyle = {
      flex: "0 0 auto"
    };
    let navstyle = {
      flex: "0 1 auto"
      // overflow: "auto"
    };

    // autocollapse all menus, but operations!
    var stCollapsed = {
      openReports: false,
      openSettings: false,
      openContacts: false,
      openAccounting: false,
      openCompany: false,
      openBudget: false
      // openOperations: true
    };

    return (
      <div
        className="sidebar"
        data-color="black"
        data-image={image}
        style={bgImage}
      >
        <ReloadModal />
        <div
          className="sidebar-background-filter-container"
          style={sideBarStyle}
        >
          <div className="sidebar-background-filter" />

          {/* <div> */}
          {/* <div className="flex"> */}
          {/* <div className="navbar-minimize margin-left-20">
                <button
                  id="minimizeSidebar"
                  className="btn btn-default btn-fill btn-round btn-icon"
                  onClick={this.handleMinimizeSidebar.bind(this)}
                >
                  <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                  <i className="fa fa-navicon visible-on-sidebar-mini" />
                </button>
              </div> */}
          {/* <button
                id="bigNLogo"
                className="btn btn-default btn-fill btn-round btn-icon"
              >
                <i className="fa fa-navicon visible-on-sidebar-mini" />N
              </button> */}
          <div >
            <a
              //href="http://www.netwips.com"
              className="logo simple-text logo-normal"
              onClick={() => {
                this.props.history.push("/companies");
              }}
            >
              <div style={{ textAlign: "center" }}>
                <img alt="" src={"/netwips_logo_blanc.png"} />
              </div>
            </a>
          </div>
          {/* </div> */}
          {/* <p className="simple-text">{companyName}</p> */}
          {/* </div> */}
          <div
            className="sidebar-wrapper"
            ref="sidebarWrapper"
          // style={sideBarStyle}
          >
            <div className="user" style={userStyle}>
              <div className="flex">
                <div className="margin-left-10">
                  <Avatar
                    email={(user && user.email) || ""}
                    name={nameStr}
                    textSizeRatio={2}
                    color={"#FFF"}
                    fgColor={"#333"}
                    size={40}
                    round={true}
                  // color={"yellow"}
                  />
                  {/* <img src={avatar} alt="Avatar" /> */}
                </div>

                {/* </div> */}
                <a
                  onClick={() => {
                    var st = Object.assign({}, stCollapsed);
                    st["openCompany"] = !this.state["openCompany"];

                    // this.setState({ openCompany: !this.state.openCompany })

                    console.log("company setState1");

                    this.setState(st);
                  }}
                >
                  <span style={{ fontSize: "110%" }}>
                    {companyName}{" "}
                    <b
                      className={
                        this.state.openCompany ? "caret rotate-180" : "caret"
                      }
                    />
                  </span>
                </a>
                {/* <button
                  id="minimizeSidebar"
                  className="btn btn-default btn-fill btn-round btn-icon"
                  onClick={this.props.handleMinimizeSidebar.bind(this)}
                >
                  <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                  <i className="fa fa-navicon visible-on-sidebar-mini" />
                </button> */}
              </div>
              <div className="info">
                <Collapse in={this.state.openCompany}>
                  <ul className="nav">
                    {/* <li>
                      <LinkContainer to="#">
                        <a>
                          <span className="">
                            <b>{firstName}</b>
                          </span>
                        </a>
                      </LinkContainer>
                    </li>
                    <li>
                      <div className="separation-line" />
                    </li> */}
                    <li>
                      <LinkContainer
                        onClick={() => {
                          console.log("openCompany false setState");

                          const token = localStorage.getItem("graphcoolToken");
                          const companyId = localStorage.getItem("companyId");

                          sessionStorage.clear();
                          localStorage.clear();

                          localStorage.setItem("graphcoolToken", token);
                          localStorage.setItem("companyId", companyId);
                          window.location.reload();

                          this.setState({ openCompany: false });
                        }}
                        to="/settings/companies"
                      >
                        <a>
                          <span className="fa fa-th-large sidebar-mini" />
                          <span className="sidebar-normal">
                            <FormattedMessage id={"ids_switchCompany"} />
                          </span>
                        </a>
                      </LinkContainer>
                    </li>
                    {/* {this.props.role === "ADMIN" && (
                      <li>
                        <LinkContainer to="/plans">
                          <a>
                            <span className="fa fa-shopping-cart sidebar-mini" />
                            <span className="sidebar-normal">
                              <FormattedMessage id={"ids_plans"} />
                            </span>
                          </a>
                        </LinkContainer>
                      </li>
                    )} */}

                    <li>
                      <div className="separation-line" />
                    </li>
                    <li>
                      <LinkContainer to="/settings/profile">
                        <a>
                          <span className="fa fa-user sidebar-mini" />
                          <span className="sidebar-normal">
                            {" "}
                            <FormattedMessage id={"ids_myProfile"} />
                          </span>
                        </a>
                      </LinkContainer>
                    </li>
                    <li>
                      <LinkContainer to="#">
                        <a onClick={() => logout()}>
                          <span className="fa fa-power-off sidebar-mini" />
                          <span className="sidebar-normal">
                            <FormattedMessage id={"ids_logout"} />
                          </span>
                        </a>
                      </LinkContainer>
                    </li>

                    {process.env.REACT_APP_HEROKU_RELEASE_CREATED_AT ? (
                      <div>
                        <li>
                          <div className="separation-line" />
                        </li>
                        <li>
                          <div className="text-center">
                            <small>
                              {/* version: {process.env.HEROKU_RELEASE_VERSION}{" "} */}
                              build:{" "}
                              {process.env.REACT_APP_HEROKU_RELEASE_CREATED_AT}
                            </small>
                          </div>
                        </li>
                      </div>
                    ) : (
                      <div />
                    )}

                    {/* <li>
                        <a>
                        <span className="sidebar-mini">EP</span>
                        <span className="sidebar-normal">Edit Profile</span>
                        </a>
                      </li>
                      <li>
                      <a>
                      <span className="sidebar-mini">S</span>
                      <span className="sidebar-normal">Settings</span>
                    </a>
                  </li> */}
                  </ul>
                </Collapse>
              </div>
            </div>
            <div style={navstyle}>
              <ul className="nav">
                {/* If we are on responsive, we want both links from navbar and sidebar
              to appear in sidebar, so we render here HeaderLinks */}
                {/* this.state.width <= 992 ? (
                <HeaderLinks
                  showCompanySwitcher={() => this.showCompanySwitcher()}
                />
              ) : null */}
                {/*
                here we render the links in the sidebar
                if the link is simple, we make a simple link, if not,
                we have to create a collapsible group,
                with the speciffic parent button and with it's children which are the links
                */}
                {dashRoutes(this.props).map((prop, key) => {
                  var st = Object.assign({}, stCollapsed);
                  st[prop["state"]] = !this.state[prop.state];

                  if (prop.visible === false) {
                    return <div key={key} />;
                  }

                  if (prop.isSeparationLine === true) {
                    return (
                      <li>
                        <div className="separation-line" />
                      </li>
                    )
                  }

                  if (prop.collapse) {
                    return (
                      <li className={this.activeRoute(prop.path)} key={key}>
                        <a
                          onClick={() => {
                            console.log("route setState1", prop.path);
                            console.log("prop", prop);
                            this.props.history.push(prop.path);
                            console.log("key", key);
                            this.setState(st);
                          }}
                        >
                          <i className={prop.icon} />
                          <p>
                            <FormattedMessage id={prop.name} />
                            <b
                              className={
                                this.state[prop.state]
                                  ? "caret rotate-180"
                                  : "caret"
                              }
                            />
                          </p>
                        </a>
                        <Collapse in={this.state[prop.state]}>
                          <ul className="nav">
                            {prop.views.map((prop, key) => {
                              if (prop.visible === false) {
                                return <div key={key} />;
                              }

                              return (
                                <li
                                  className={this.activeRoute(prop.path)}
                                  key={key}
                                >
                                  <NavLink
                                    onClick={() => {
                                      console.log("route link", prop.path);
                                      document.documentElement.classList.toggle(
                                        "nav-open"
                                      );
                                    }}
                                    to={prop.path}
                                    className="nav-link"
                                    activeClassName="active"
                                  >
                                    <span
                                      style={emptyMiniStyle}
                                      className="sidebar-mini"
                                    >
                                      {" "}
                                    </span>
                                    <span className="sidebar-normal">
                                      <FormattedMessage id={prop.name} />
                                    </span>
                                  </NavLink>
                                </li>
                              );
                            })}
                          </ul>
                        </Collapse>
                      </li>
                    );
                  } else {
                    if (prop.redirect) {
                      return null;
                    } else {
                      st = Object.assign({}, stCollapsed);
                      return (
                        <li
                          onClick={() => {
                            this.setState(st);
                            document.documentElement.classList.toggle(
                              "nav-open"
                            );
                          }}
                          className={this.activeRoute(prop.path)}
                          key={key}
                        >
                          <NavLink
                            to={prop.path}
                            className="nav-link"
                            activeClassName="active"
                          >
                            <i className={prop.icon} />
                            <p>
                              <FormattedMessage id={prop.name} />
                            </p>
                          </NavLink>
                        </li>
                      );
                    }
                  }
                })}
                <li className="navbar-minimize">
                  {/*<a
                    id="minimizeSidebar"
                    className="navlink"
                    onClick={this.handleMinimizeSidebar.bind(this)}
                    >
                    <i className="fa fa-arrows-h" />
                    <p className="sidebar-normal">
                    {this.state.navExpanded ? "Reduce" : "Expand"}
                  </p>
                </a>*/}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ReloadModal extends Component {
  state = {
    show: false
  };
  componentDidMount() {
    // Handle global event.
    // console.log("ReloadModal - setup event listener");
    window.addEventListener("newContentAvailable", () => {
      console.log("newContentAvailable event catched, should display modal");
      this.setState({
        show: true
      });
    });
  }
  onClick = () => {
    // Reload when modal click.
    window.location.reload(window.location.href);
  };
  render() {
    if (!this.state.show) {
      return null;
    }

    // <Modal> is common fixed component.
    return (
      <div>
        <Modal
          dialogClassName={"custom-modal"}
          show={true}
          onHide={this.onClick}
        >
          <Modal.Header closeButton>
            New content is available once existing tabs are closed. Please close
            tabs to upgrade.
          </Modal.Header>
          {/* <Modal.Body>
            <span onClick={this.onClick}>Veuillez recharger la page </span>
          </Modal.Body> */}
        </Modal>
      </div>
    );
  }
}
export default compose(
  graphql(Queries.userProfile, { name: "userProfile" }),
  graphql(Queries.companyQueryForSidebar, { name: "companyQuery" })
  // graphql(Queries.userProfileQuery, { name: "userProfile" }),
  // graphql(Queries.companyQueryForSidebar, { name: "companyQuery" })
)(withRouter(Sidebar));
